import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';

import 'url-search-params-polyfill';

import { isMyAccount, isKrakenMyAccount } from 'src/utils/helpers';

import { Root } from './root';

declare const __BASEPATH__: string,
  __BASEPATH_AUTH__: string,
  __BASEPATH_RX__: string,
  __DEV__: boolean;

const getBasename = () => {
  if (isMyAccount()) {
    return __BASEPATH_AUTH__;
  }

  if (isKrakenMyAccount()) {
    return __BASEPATH_RX__;
  }

  return __BASEPATH__;
};

const Application: React.SFC = () => (
  <BrowserRouter basename={getBasename()}>
    <Root />
  </BrowserRouter>
);

const Component = __DEV__ ? require('react-hot-loader').hot(module)(Application) : Application;

export default Component;
